<template>
    <router-link :to="{name: 'docs', params: {chapter: 'metric-exporters', group: exporter, item: 'metrics' }, hash:`#${name}`}">
        <span v-if="alias" class="name">{{alias}}</span>
        <span v-else class="name">{{name}}</span>
    </router-link>
</template>

<script>
export default {
    props: {
        exporter: String,
        name: String,
        alias: String,
    },
};
</script>

<style scoped>
.name {
    word-break: break-all;
}
</style>
